import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar/Sidebar';

const MainLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { navLink: '/notification-template', navItem: 'Notification Template' },
    { navLink: '/users', navItem: 'User' },
    { navLink: '/feedbacks', navItem: 'Feedbacks' },
    { navLink: '/products', navItem: 'Products' },
    { navLink: '/orders', navItem: 'Orders' },
    { navLink: '/employee-rating', navItem: 'Employee Rating' },
    { navLink: '/totaltreatments', navItem: 'Total Treatments' },
    { navLink: '/diet', navItem: 'Diet' },
    { navLink: '/diet-plan-template', navItem: 'Diet Plan Template' },
    { navLink: '/banners', navItem: 'Banners' },
    { navLink: '/treatment', navItem: 'Diseases Treated' },
    { navLink: '/coupons', navItem: 'Coupons' },
    { navLink: '/privacy-policy', navItem: 'Privacy Policy' },
    { navLink: '/blog', navItem: 'Blog' }
  ];

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('');
  };

  const allowSideBar = (location.pathname.toLowerCase() !== '/privacy-policy' && location.pathname.toLowerCase() !== '/campingform')

  return (
    <div className="d-flex">
      {allowSideBar && (
        <Sidebar navItems={navItems} onLogout={handleLogout} />
      )}
      <div className="py-4 px-3" style={{ overflow: 'auto', height: '100vh', width: (allowSideBar ? '90vw' : '100%') }}>
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
